import { defineStore } from "pinia";
import api from "~/config/extensionsApi";
import axios from "axios";
import { useClientStore } from "./client";

let url =
  api.facebookapi.endpoint.URL_FIXEL +
  `${api.facebookapi.endpoint.API_VERSION}/${api.facebookapi.endpoint.PIXEL_ID}/events?access_token=${api.facebookapi.endpoint.access_token}`;
let url_v2 =
  api.facebookapi.endpoint.URL_FIXEL +
  `${api.facebookapi.endpoint.API_VERSION}/${api.facebookapi.endpoint.PIXEL_ID2}/events?access_token=${api.facebookapi.endpoint.access_token_v2}`;

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}

async function sha256(message) {
  const msgBuffer = new TextEncoder().encode(message);
  const hashBuffer = await crypto.subtle.digest("SHA-256", msgBuffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
  return hashHex;
}

function replaceUndefinedValue(data) {
  try {
    data = JSON.stringify(data);
    data.replace("undefined", "null");
    data = JSON.parse(data);

    return data;
  } catch (error) {
    console.error("error: ", error);
  }
}

async function convertData(data, eventName = "ViewContent") {
  let email = null;
  let phone = null;
  let dob = null;
  let firstname = null;
  let lastname = null;
  let address = null;
  let city = null;
  let country = null;
  let state = null;
  let external_id = null;
  if (data?.userData) {
    email = data?.userData?.email ? await sha256(data.userData.email) : null;
    phone = data?.userData?.phone_number ? await sha256(data.userData.phone_number) : null;
    dob = data?.userData?.dob ? await sha256(String(data.userData.dob)) : null;
    firstname = data?.userData?.firstname ? await sha256(data.userData.firstname) : null;
    lastname = data?.userData?.lastname ? await sha256(data.userData.lastname) : null;
    address = data?.userData?.addresses?.find((e) => e.default_shipping == true) || data?.userData?.addresses?.[0];
    state = address?.city ? await sha256(address.city) : null;
    country = address?.country_code ? await sha256(address.country_code) : null;
    city = address?.region?.region ? await sha256(address.region.region) : null;
    external_id = data?.userData?.customer_id ? String(data.userData.customer_id) : null;
  }

  const clientStore = useClientStore();
  const clientIp = clientStore.getClientIp;
  let contentId = data?.product?.parentSku ? data?.product?.parentSku : data?.product?.sku;
  if (contentId) {
    const param = {
      data: [
        {
          event_name: eventName,
          event_time: Math.floor(new Date().getTime() / 1000),
          user_data: {
            external_id: [external_id],
            client_ip_address: clientIp,
            client_user_agent: window.navigator.userAgent,
            fbc: getCookie("_fbc"),
            fbp: getCookie("_fbp"),
            em: [email],
            ph: [phone],
            db: [dob],
            fn: [firstname],
            ln: [lastname],
            country: [country],
            st: [state],
            ct: [city],
            zp: [state],
          },
          custom_data: [
            {
              content_ids: contentId,
              content_name: data?.product?.name,
              contents: [
                {
                  id: data?.product?.sku || data?.product?.parentSku,
                  quantity: 1,
                  item_price: data?.product?.final_price ? data?.product?.final_price : data?.product?.original_price,
                },
              ],
              content_type: "product",
              value: data?.product?.final_price ? data?.product?.final_price : data?.product?.original_price,
              currency: "VND",
            },
          ],
          action_source: "website",
        },
      ],
    };
    return param;
  }
}

export const useFacebookApi = defineStore("facebookApi", {
  state: () => ({
    // Define any state properties here if needed
  }),

  getters: {
    // Define any getters here if needed
  },

  actions: {
    async pagviewFacebookApi(data) {
      try {
        data = replaceUndefinedValue(data);
        let rs = await axios.post(url, data);
      } catch (error) {
        console.error("error: ", error);
      }
    },

    async viewContentFacebookApi(data) {
      console.log("Facebook Api - ViewContent:", data);

      try {
        data = replaceUndefinedValue(data);
        const dataConverted = await convertData(data, "ViewContent");
        let rs = await axios.post(url, dataConverted);
        let rs_v2 = await axios.post(url_v2, dataConverted);
      } catch (error) {
        console.error("error: ", error);
      }
    },

    async addToCartFacebookApi(data) {
      try {
        data = replaceUndefinedValue(data);
        const dataConverted = await convertData(data, "AddToCart");
        console.log("Facebook Api - AddToCart:", dataConverted);
        await axios.post(url, dataConverted);
        await axios.post(url_v2, dataConverted);
      } catch (error) {
        console.error("error: ", error);
      }
    },

    async initCheckoutFacebookApi(info) {
      try {
        const data = info?.stock || {};
        let email = null;
        let phone = null;
        let dob = null;
        let firstname = null;
        let lastname = null;
        let address = null;
        let city = null;
        let country = null;
        let state = null;
        let external_id = null;
        if (data?.userData) {
          email = data?.userData?.email ? await sha256(data.userData.email) : null;
          phone = data?.userData?.phone_number ? await sha256(data.userData.phone_number) : null;
          dob = data?.userData?.dob ? await sha256(String(data.userData.dob)) : null;
          firstname = data?.userData?.firstname ? await sha256(data.userData.firstname) : null;
          lastname = data?.userData?.lastname ? await sha256(data.userData.lastname) : null;
          address = data?.userData?.addresses?.find((e) => e.default_shipping == true) || data?.userData?.addresses?.[0];
          state = address?.city ? await sha256(address.city) : null;
          country = address?.country_code ? await sha256(address.country_code) : null;
          city = address?.region?.region ? await sha256(address.region.region) : null;
          external_id = data?.userData?.customer_id ? String(data.userData.customer_id) : null;
        }
        const clientStore = useClientStore();
        const clientIp = clientStore.getClientIp;
        let paramData = [
          {
            event_name: "InitiateCheckout",
            event_time: Math.floor(new Date().getTime() / 1000),
            user_data: {
              external_id: [external_id],
              client_ip_address: clientIp,
              client_user_agent: window.navigator.userAgent,
              fbc: getCookie("_fbc"),
              fbp: getCookie("_fbp"),
              em: [email],
              ph: [phone],
              db: [dob],
              fn: [firstname],
              ln: [lastname],
              country: [country],
              st: [state],
              ct: [city],
              zp: [state],
            },
            custom_data: [
              {
                content_type: data.content_type,
                content_ids: data.content_ids,
                content_name: data.content_name,
                number_items: data.number_items,
                value: parseFloat(data.value),
                currency: data.currency,
              },
            ],
            action_source: "website",
          },
        ];
        paramData = replaceUndefinedValue(paramData);
        console.log("Facebook Api - InitiateCheckout:", paramData);
        await axios.post(url, { data: paramData });
        await axios.post(url_v2, { data: paramData });
      } catch (error) {
        console.error("error: ", error);
      }
    },

    async purcherFacebookApi(info) {
      try {
        const data = info?.order || {};
        let email = null;
        let phone = null;
        let dob = null;
        let firstname = null;
        let lastname = null;
        let address = null;
        let city = null;
        let country = null;
        let state = null;
        let external_id = null;
        if (info?.userData) {
          email = info?.userData?.email ? await sha256(info.userData.email) : null;
          phone = info?.userData?.phone_number ? await sha256(info.userData.phone_number) : null;
          dob = info?.userData?.dob ? await sha256(String(info.userData.dob)) : null;
          firstname = info?.userData?.firstname ? await sha256(info.userData.firstname) : null;
          lastname = info?.userData?.lastname ? await sha256(info.userData.lastname) : null;
          address = data?.orderAddress || info?.userData?.addresses?.find((e) => e.default_shipping == true) || info?.userData?.addresses?.[0];
          if (address) {
            state = address.city ? await sha256(address.city) : null;
            country = address.country_code ? await sha256(address.country_code) : await sha256("VN");
            if (address.region && typeof address.region === "string") {
              city = await sha256(address.region.region);
            } else if (address.region && address.region.region) {
              city = (await sha256(address.region.region)) || null;
            }
          }
          external_id = info?.userData?.customer_id ? String(info.userData.customer_id) : null;
        }
        const clientStore = useClientStore();
        const clientIp = clientStore.getClientIp;
        let paramData = [
          {
            event_name: "Purchase",
            event_time: Math.floor(new Date().getTime() / 1000),
            user_data: {
              external_id: [external_id],
              client_ip_address: clientIp,
              client_user_agent: window.navigator.userAgent,
              fbc: getCookie("_fbc"),
              fbp: getCookie("_fbp"),
              em: [email],
              ph: [phone],
              db: [dob],
              fn: [firstname],
              ln: [lastname],
              country: [country],
              st: [state],
              ct: [city],
              zp: [state],
            },
            contents: data?.contents,
            custom_data: {
              value: parseFloat(data?.value),
              currency: data.currency,
              content_ids: data?.contents.map((item) => item.id),
              contents: data?.contents,
              id: data?.id,
              coupon: data?.coupon,
              shipping: data?.shipping,
            },
            action_source: "website",
          },
        ];
        paramData = replaceUndefinedValue(paramData);
        console.log("Facebook Api - Purchase:", paramData);
        await axios.post(url, { data: paramData });
        await axios.post(url_v2, { data: paramData });
      } catch (error) {
        console.error("error: ", error);
      }
    },
  },
});
